import { formToSearchParams, applyRegionMunicipality } from "./params";
import initPagination from "../listings/pagination";
import markerManager from "../map/markers";
import { debounce } from "../utils/dom";
import popupTemplate from "../../../templates/popup-template.hbs";

export default function initSearch({ map, ajaxUrl, templates } = {}) {
    const form = document.querySelector("#advanced--search");
    const sale_status = document.querySelector('select[name="sale_status"]');
    const minPrice = document.querySelector(".price_min");
    const maxPrice = document.querySelector(".price_max");
    const mapSearch = document.querySelector('[name="mapSearch"]');

    console.log("initSearch is called");

    if (!form) return;

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        const url = new URL(window.location.href);
        let searchParams = formToSearchParams(form);

        if (searchParams.has("q") && searchParams.has("bounds"))
            searchParams.delete("bounds");

        if (sale_status) {
            if (sale_status.value === "rent") {
                searchParams.delete("price_min");
                searchParams.delete("price_max");
            } else if (sale_status.value === "sale") {
                searchParams.delete("price_rent_min");
                searchParams.delete("price_rent_max");
            }
        }

        // region / municipality handling
        searchParams = applyRegionMunicipality(searchParams, form);

        // update history
        url.search = searchParams.toString();
        window.history.replaceState({}, "", url.toString());

        // re-init pagination (this will fetch the listing cards)
        initPagination({ map, ajaxUrl, templates, forceParams: searchParams });

        // if searching via mapSearch flag, also refresh markers (bounds-based)
        if (mapSearch && mapSearch.value) {
            const boundsInput = document.querySelector('[name="bounds"]');
            const bounds = boundsInput ? boundsInput.value : null;
            markerManager.init(map, { templates: popupTemplate });
            markerManager.loadMarkers({ bounds, extraParams: searchParams });
        }

        // reset byMove flag
        form.dataset.byMove = "false";
    });

    // nicer UX: switch price input names on sale_status change
    if (sale_status) {
        sale_status.onchange = (e) => {
            if (minPrice) minPrice.value = "";
            if (maxPrice) maxPrice.value = "";

            if (e.target.value === "rent") {
                minPrice?.setAttribute("name", "price_rent_min");
                maxPrice?.setAttribute("name", "price_rent_max");
            } else if (e.target.value === "sale") {
                minPrice?.setAttribute("name", "price_min");
                maxPrice?.setAttribute("name", "price_max");
            }
        };
    }

    // region select custom handler remains mostly same
    $(document).on("click", ".region-select .option", function () {
        const select = $(this).closest(".nice-select").prev("select");
        setTimeout(() => select.trigger("change"), 0);
    });

    $(".region-select").on("change", function () {
        const selectedInputVal = $(this).val();
        const selectedOption = $("option:selected", this);
        const dataCoords = selectedOption.data("latlng");
        if (!dataCoords) return;
        const latlng = dataCoords.split(",");
        const lat = +latlng[0];
        const lng = +latlng[1];
        if (map && map.setView) map.setView([lat, lng], 11);
    });
}
